import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from 'rebass/styled-components';
import moment from 'moment';
import { JobApplications } from './jobApplications';

export const JobSeeking = ({ jobApplications, signupInfo = {}, contactId }) => (
  <>
    <Text mt="8px" fontSize="14px" fontWeight="medium" color="text.dark">
      Talent Network signup info
    </Text>
    <Box mt="16px">
      {signupInfo && (
        <Box sx={{ display: 'grid', gridTemplateColumns: '160px 1fr', gap: '8px' }}>
          {signupInfo.signupDate && (
            <>
              <Text fontSize="14px" color="text.subtle">
                Signup date
              </Text>
              <Text fontSize="14px">{moment(signupInfo.signupDate).format('MMM DD, YYYY')}</Text>
            </>
          )}
          {!!signupInfo?.jobFunctions?.length && (
            <>
              <Text fontSize="14px" color="text.subtle">
                Job function
              </Text>
              <Text fontSize="14px">{signupInfo?.jobFunctions?.join(', ')}</Text>
            </>
          )}
          {!!signupInfo?.seniorities?.length && (
            <>
              <Text fontSize="14px" color="text.subtle">
                Level of experience
              </Text>
              <Text fontSize="14px">{signupInfo.seniorities?.join(', ')}</Text>
            </>
          )}
          {!!signupInfo?.locationPreferences?.length && (
            <>
              <Text fontSize="14px" color="text.subtle">
                Preferred locations
              </Text>
              <Text fontSize="14px">{signupInfo.locationPreferences?.join(' · ')}</Text>
            </>
          )}
          {!!signupInfo?.workEnvironments?.length && (
            <>
              <Text fontSize="14px" color="text.subtle">
                Work environment
              </Text>
              <Text fontSize="14px">{signupInfo.workEnvironments?.join(', ')}</Text>
            </>
          )}
          {!!signupInfo?.jobSearchStatus && (
            <>
              <Text fontSize="14px" color="text.subtle">
                Job search status
              </Text>
              <Text fontSize="14px">{signupInfo.jobSearchStatus}</Text>
            </>
          )}
        </Box>
      )}
      {(!signupInfo || !Object.keys(signupInfo).length) && (
        <Text fontSize="14px" color="text.subtle" fontStyle="italic">
          This user has not signed up to your Talent Network.
        </Text>
      )}
    </Box>

    <JobApplications jobApplications={jobApplications} contactId={contactId} />
  </>
);

JobSeeking.propTypes = {
  signupInfo: PropTypes.object,
  jobApplications: PropTypes.array,
  contactId: PropTypes.string,
};

JobSeeking.defaultProps = {
  signupInfo: {},
  jobApplications: [],
  contactId: '',
};
